import {FC} from 'react'
import {FormChangeRooms} from '../components/Forms/FormChangeRooms'

const HeaderChangeRoomsPanel: FC = () => {
  return (
    <>
      <FormChangeRooms />
    </>
  )
}

export {HeaderChangeRoomsPanel}
